




function monthLength(year, month) {
    var dd = new Date(year, month + 1, 0);
    return dd.getDate();
}

(function () {
    Calendar = function () {
        var $ = this;

        $.frame = _E("<div cal_frame escdie></div>");
        var kill = _E("<kill  style='position:absolute;right:-.3em;top:-.3em;'>"),
            wrp = _E("<div style='position:relative;'></div>"),
            hwrp = _E("<div style='padding:.2em 0;margin-bottom:.3em'></kill></div>"),
            bwrp = _E("<div ctrl_tb_wrapper></div>"),
            lcol = _E("<div cal_left_col></div>"),
            rcol = _E("<div cal_right_col></div>"),
            today = _E("<div today title='today' ></div>"),
            clock = _E("<div clock title='clock' _disabled></div>").setA("btn"),
            back = _E("<div back></div>"),
            next = _E("<div next></div>"),
            drag = _E();
        $.panel = $.frame;
        $.month = _E("<div month  noselect style='margin-left:1.5em;'></div>");
        $.year = _E("<div year contenteditable></div>");
        $.year.on("keypress", function (ev) {
            if (ev.which === 13) {
                $.din[0] = $.year.html.trim();
                ev.preventDefault();
                $.build($.din.join("-"));
                return false;
            }
        });
        $.frame._(drag, wrp);
        wrp._(kill, hwrp, bwrp);
        hwrp._(back, next, $.month, $.year);
        bwrp._(lcol, rcol);
        lcol._(today);

        $.clock_wrapper = _E().setA("clock_wrapper");
        $.timer = _E("input").setA({ type: "time", step: "1" }).css({ "min-height": "auto", padding: ".2em", "margin-left": ".3em" });
        $.frame._($.clock_wrapper._($.timer, clock))

        var s = "<table style='table-layout:fixed;' cal_days><thead><tr>";
        Date.prototype.dayNames.map(function (d) {
            s += ("<td>" + d + "</td>");
        });
        $.table = _E(s + "</tr></thead><tbody></tbody></table>");
        rcol._($.table);


        // reactions
        back.on('click', function () {
            var a = $.din;
            a[1]--;
            if (a[1] <= 0) {
                a[1] = 12;
                a[0]--;
            }
            $.build(a[0] + "-" + a[1] + "-1");
        });
        next.on('click', function () {
            var a = $.din;
            a[1]++;
            if (a[1] > 12) {
                a[1] = 1;
                a[0]++;
            }
            $.build(a[0] + "-" + a[1] + "-1");
        });
        today.on("click", function () {
            $.build(Date.now());
            $.table.scale(1);
        });
        var as_clock;
        clock.on("click", function () {
            var S = ($.input.value.trim().match(/\b[^\s]*/) || [])[0];
            if (S) {
                $.input.value = S + " " + ($.timer.value || (new Date).time);
                $.input.fire("change");
            } else {
                $.input.show_error("SELECT A DATE FIRST")
            }
        });
        $.table.on("click", function (ev) {
            if ($.input && ev.target.tagName === "TD" && ev.target.hasA("cal_day")) {
                $.input.value = $.din[0] + "-" + $.din[1] + "-" + ev.target.html;
                $.input.fire("change");
            }
        });
        kill.on("click", function () {
            Q.AST.awake = 0;
        });

        $.trig('color', function (x) {
            //$.head.css('background:' + x + ';');
        }, '#ffcc33');

        $.trig("input", function (elm) {
            $.set(elm.value);
        });

        $.set = function (val) {
            var d = new Date(val);
            if (!d.yy)
                d = new Date(); // daca am valoare inproprie duc la zi
            $.mem = [d.yy, d.mm, d.dd];
            $.build(val);
        };
        $.set();
    };


    Calendar.prototype = {
        build: function (val) { // asteapta data in human mode [1-12]
            var $ = this;
            var now = new Date(), // data curenta
                valid_val = !(new Date(val) == "Invalid Date"),
                last_month = val && valid_val ? new Date(val) : new Date(), //pentru calculul de afisare al datelor din luna anterioara
                din = val && valid_val ? new Date(val) : new Date(), // data pt care se face constructia
                now_ar = [now.yy, now.mm, now.dd],
                din_ar = [din.yy, din.mm, din.dd],
                n = din.monthLength, // nr de zile
                d = new Date(din_ar[0], din_ar[1], 1).getDay(), // pozitia primei zile pe colane
                N = 0; // contor
            if (!valid_val && $.input) { $.input.value = ''; }
            $.din = [din_ar[0], din_ar[1] + 1, 1];
            $.year.html = din_ar[0];
            $.month.html = Date.prototype.monthNames[din_ar[1]].substring(0, 3);
            last_month.setDate(1);
            last_month.setMonth(last_month.getMonth() - 1);
            var n_last = last_month.monthLength;
            $.current_month_length = n;
            var s = "<tr>";
            for (var i = n_last - d + 1; i <= n_last; i++) {
                s += "<td cal_dout>" + i + "</td>"; //aici se genereaza celulele pentru zilele lunii anterioare care se vor afisa cu luna curenta
                N++;
            }
            for (var i = 1; i <= n; i++) {
                var ap = '';
                if (din_ar[0] === now_ar[0] && din_ar[1] === now_ar[1] && i === now_ar[2]) {
                    ap += ' cal_today';
                }
                if (din_ar[0] === this.mem[0] & din_ar[1] === this.mem[1] && i === this.mem[2]) {
                    ap += " style='background:" + this.color + "'";
                }
                s += "<td cal_day" + ap + ">" + i + "</td>";
                N++;
                if (N === 7) {
                    s += "</tr><tr>";
                    N = 0;
                }
            }
            for (var i = 1; N > 0 && i < (8 - N); i++)
                s += "<td cal_dout>" + i + "</td>";//aici se genereaza celulele pentru zilele lunii viitoare care se vor afisa cu luna curenta
            this.table.tBodies[0].html = (s + "</tr>");
            $.frame.fire("input_assist_panel_ready", { widget: $ });// ????? 
            $.frame.fire("date_change");
            if ($.input && $.input.cdf) {
                $.frame.setA("type", $.input.getA("sql_type"));
            }
            return this;
        }
    };
    Object.defineProperty(Calendar.prototype, 'toString', {
        value: function () {
            return "Calendar";
        }
    });

    Date.piker = function (label) {
        var d = _E().setA({ date_piker: 1, active_editing: 1 }).css("display:inline-block;width:7.5em;position:relative"),
            pik_btn = _E('<piker ast="calendar" ></piker>'),
            inp = _E('input').setA({ sql_type: 'date' }).css("width:7.5em;padding:.35em .5em");
        pik_btn.target = inp;
        inp.piker = pik_btn;
        inp.ast = 'calendar';
        d._(pik_btn, inp, _E('span', label));
        var wrap = _E('span')._(d);
        wrap.input = inp;
        Object.defineProperty(wrap, 'value', {
            get: function () {
                return inp.value;
            },
            set: function (v) {
                inp.value = v;
            }
        });
        return wrap;
    };


})();


